
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import SystemEvaluationMetricsContent from "./components/SystemEvaluationMetricsContent.vue";

export default defineComponent({
  name: "SystemEvaluationMetricsPage",
  components: {
    BreadCrumb,
    SystemEvaluationMetricsContent,
  },
});
